export default function Footer() {
  return (
    <footer>
      © 2026 Pratik • All Rights Reserved
    </footer>
  );
}
